// extracted by mini-css-extract-plugin
module.exports =  {"button":"_2787e5dfdf--button--pv5jF","dark":"_2787e5dfdf--dark--SHfpm"};